import { render, staticRenderFns } from "./HelipadPost.vue?vue&type=template&id=72db3129&"
import script from "./HelipadPost.vue?vue&type=script&lang=js&"
export * from "./HelipadPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports